import produce from 'immer';

// TYPES
import { Types, ConsultaGfor } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: ConsultaGfor = {
	status: 0,
	data: null,
	cpf: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaGfor {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_GFOR_REQUEST: {
				draft.status = 100;
				break;
			}

			case Types.CONSULTA_GFOR_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.CONSULTA_GFOR_FAILURE: {
				draft.status = 0;
				break;
			}

			case Types.CONSULTA_GFOR_CLEAR: {
				draft.data = INITIAL_STATE.data;
				draft.status = INITIAL_STATE.status;
				break;
			}

			default:
		}
	});
}
